import styled from '@emotion/styled'
import { tokens } from '@news-mono/design-tokens'
import { breakpoint, calcRem } from '../../__styling'
import { IconAlertCirclePN, IconCheckmarkTN } from '../../icons'
import React from 'react'
import { PNToastProps } from './PNToastNotification.routing'

// PerthNow Colors
const pnColors = tokens.perthnow.colors
const pnPalette = pnColors.palette

export const StyledToastIconContainer = styled('div')<PNToastProps>(
    ({ type }) => ({
        display: 'flex',
        maxWidth: calcRem(24),
        maxHeight: calcRem(24),
        width: '100%',
        margin: `auto ${calcRem(8)} auto 0`,

        // We need to add stroke styling in order to allow
        // it to accept pinkThulite like the text for verify
        // PN Toast Notification
        path: {
            stroke: type === 'verify' ? pnPalette.pinkThulite : undefined,
        },

        // Large mobile or bigger styling
        [breakpoint('sm')]: {
            path: {
                stroke: type === 'verify' ? 'revert-layer' : undefined,
            },
        },
    }),
)

export const StyledToastCheckmarkIcon = styled(IconCheckmarkTN)({
    width: calcRem(24),
    height: calcRem(24),

    path: {
        stroke: pnPalette.greenJadeShade[600],
    },
})

export const StyledToastInfoIcon: React.FC<PNToastProps> = ({ type }) => (
    <IconAlertCirclePN
        strokeColor={
            type === 'error' || type === 'warning'
                ? pnPalette.redCrisis[600]
                : type === 'verify'
                ? pnPalette.pinkThuliteShade[600]
                : pnPalette.blackShade[100]
        }
    />
)
